// extracted by mini-css-extract-plugin
module.exports = {"gfeButton":"GfeButton_gfeButton__-6L6J"};